import React from "react";
import { css } from "@emotion/core";
// material-ui
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/modalStyle.js";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// styles
import { DatesContainer, TitleModalStyled, InfoContainer } from "./styles";

// core components
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "components/CustomButtons/Button.js";
import { BLUE_RGB } from "utils/colorsTheme";
import FileUpload from "components/CustomUpload/FileUpload";
import Datetime from "react-datetime";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import BeatLoader from "react-spinners/BeatLoader";
import { Link } from "react-router-dom";

// components

const useStyles = makeStyles(styles);
const override = css`
  display: block;
  margin: 2rem auto;
  text-align: center;
`;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const PricesModals = React.memo(
  ({
    title,
    isOpen,
    isLoading,
    startDate,
    endDate,
    inserted,
    ignored,
    showLast,
    onChangeStartDate = () => {},
    onChangeEndDate = () => {},
    onClose = () => {},
    onSubmit = () => {},
    ...props
  }) => {
    const classes = useStyles({ color: BLUE_RGB });

    return (
      <React.Fragment>
        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal,
          }}
          open={isOpen}
          transition={Transition}
          keepMounted
          onClose={() => onClose()}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => onClose()}
            >
              <Close className={classes.modalClose} />
            </Button>
            <TitleModalStyled color={BLUE_RGB} className={classes.modalTitle}>
              {title}
            </TitleModalStyled>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
          >
            <FileUpload text="Subir archivo" {...props} />
            <DatesContainer>
              <InputLabel>Desde:</InputLabel>
              <FormControl>
                <Datetime
                  onChange={onChangeStartDate}
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  value={startDate}
                />
              </FormControl>
              <br />
              <InputLabel>A:</InputLabel>
              <FormControl>
                <Datetime
                  onChange={onChangeEndDate}
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  value={endDate}
                />
              </FormControl>
            </DatesContainer>
            {showLast && (
              <InfoContainer>
                <p>
                  {inserted} insertados, {ignored} sin insertar,{" "}
                  <Link to="/admin/precios-log">Ver más...</Link>
                </p>
              </InfoContainer>
            )}

            <BeatLoader
              css={override}
              size={15}
              color={BLUE_RGB}
              loading={isLoading}
            />
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
            <Button color="success" onClick={onSubmit}>
              Subir
            </Button>

            <Button onClick={() => onClose()} color="info">
              Salir
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
);

export default PricesModals;
